import classes from './ReviewQualifiedRealPlay.module.scss';
import RealPlayHeaderQualified from './RealPlayHeaderQualified';
import RealPlayLeftSection from './RealPlayLeftSection';
import RealPlayRightSection from './RealPlayRightSection';
import ReviewQualifiedRealplayLogic from './ReviewQualifiedRealplay.logic';
import { Skeleton } from '@material-ui/lab';
import NewReviewQualifiedRoleplay from './NewReviewQualifiedRoleplay';
const ReviewQualifiedRealplay = () => {
  const { isLoading, loadingScenarioResponseInfo, showNewReport, isLoadingFlag } =
    ReviewQualifiedRealplayLogic();

  if (isLoading || isLoadingFlag)
    return (
      <div>
        <div className={classes.headerContainer}>
          <Skeleton variant="rect" width="95%" style={{ borderRadius: '0.5rem' }} />
        </div>
        <div className={classes.container}>
          <div className={classes.left}>
            <Skeleton
              variant="rect"
              width="100%"
              height="80vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </div>
          <div className={classes.right}>
            <Skeleton
              variant="rect"
              width="100%"
              height="80vh"
              style={{ borderRadius: '0.5rem' }}
            />
          </div>
        </div>
      </div>
    );
  return showNewReport ? (
    <NewReviewQualifiedRoleplay isLoadingResponse={loadingScenarioResponseInfo} />
  ) : (
    <div>
      <div className={classes.headerContainer}>
        <RealPlayHeaderQualified isLoading={isLoading} />
      </div>

      <div className={classes.container}>
        <div className={classes.left}>
          <RealPlayLeftSection
            isLoading={isLoading}
            isLoadingResponse={loadingScenarioResponseInfo}
          />
        </div>
        <div className={classes.right}>
          <RealPlayRightSection
            isLoading={isLoading}
            isLoadingResponse={loadingScenarioResponseInfo}
          />
        </div>
      </div>
    </div>
  );
};
export default ReviewQualifiedRealplay;
